import * as R from 'ramda'
import rentIncome from './rentIncome'
import expenses from './expenses'

export default (invoicesByPropertyID, billsByPropertyID) => {
	let currRentIncome = rentIncome(invoicesByPropertyID)
	let currExpenses = expenses(billsByPropertyID)

	let properties = R.merge(currRentIncome, currExpenses)
	let netIncome = R.mapObjIndexed((_, propertyID) => (currRentIncome[propertyID] || 0) - (currExpenses[propertyID] || {total: 0}).total)(properties)

	return netIncome
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/netIncome.js